<template>
  <b-container fluid>
    <b-row class="mt-2 mb-3">
      Site url : <a href="https://mapgisol.ines-solaire.org">https://mapgisol.ines-solaire.org</a>
    </b-row>
    <b-row class="mb-5">
      <b-col lg="2">
        <div class="mb-3">
          <div class="mb-3">
            <b-button
              variant="primary"
              @click="showSettings"
              block
              class="mb-3"
            >
              Paramètres
            </b-button>
          </div>
          <b-button
            variant="primary"
            @click="showModalAddInstallation"
            block
            class="mb-3"
          >
            Nouvelle installation
          </b-button>
        </div>
      </b-col>

      <b-col lg="10">
        <b-row>
          <b-col lg="6" class="my-1">
            <b-form-group
              label="Filter"
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                ></b-form-input>

                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button @click="getAllInstallations" class="mr-1">All</b-button>
            <b-button
              :variant="dark ? 'dark' : 'light'"
              @click="dark = !dark"
              class="mr-1"
              ><b-icon :icon="dark ? 'sun' : 'moon'" aria-hidden="true"></b-icon
            ></b-button>
            <!-- <b-button variant="info" @click="stickyHeader">Sticky header</b-button> -->
          </b-col>
        </b-row>
        <b-table
          striped
          hover
          responsive
          :sticky-header="isStickyHeader"
          :dark="dark"
          :filter="filter"
          :items="installations"
          :fields="fields"
        >
          <template #cell(actions)="row">
            <b-button
              @click="showDeleteModal(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="danger"
              block
            >
              Supprimer
            </b-button>
            <b-button
              @click="showEditModal(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="warning"
              block
            >
              Modifier
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <ModalAddInstallation
      v-if="isShowInstallationModal"
      :installation="installation"
    ></ModalAddInstallation>

    <modal-settings/>
  </b-container>
</template>

<script>
import ModalAddInstallation from "./ModalAddInstallation.vue";
import ModalSettings from './ModalSettings.vue';

export default {
  name: "InstallationsManagement",
  data() {
    return {
      installations: [],
      installation: {},
      windowHeight: window.innerHeight - 120,
      isStickyHeader: window.innerHeight - 120 + "px",
      dark: true,
      isShowInstallationModal: false,
      filter: "",
      fields: [
        {
          key: "id",
          sortable: true,
        },

        {
          key: "city",
          sortable: true,
        },
        {
          key: "postalCode",
          sortable: true,
        },
        {
          key: "lat",
          sortable: true,
        },
        {
          key: "lng",
          sortable: true,
        },
        {
          key: "actions",
          sortable: true,
        },

        {
          key: "inUse",
          sortable: true,
        },
        {
          key: "inConstruction",
          sortable: true,
        },
        {
          key: "infosLinks",
          sortable: true,
        },
        {
          key: "description",
          sortable: true,
        },
        {
          key: "annualProductionDate",
          sortable: true,
        },
        {
          key: "annualProduction",
          sortable: true,
        },
        {
          key: "power",
          sortable: true,
        },
        {
          key: "capteursType",
          sortable: true,
        },
        {
          key: "stockage",
          sortable: true,
        },
        {
          key: "surfaceCapteurs",
          sortable: true,
        },
        {
          key: "commissioningYear",
          sortable: true,
        },
        {
          key: "installationType",
          sortable: true,
        },
        {
          key: "createdAt",
          sortable: true,
        },
        {
          key: "updatedAt",
          sortable: true,
        },
      ],
    };
  },
  components: {
    ModalAddInstallation,
    ModalSettings,
  },
  mounted() {
    console.log("installations component");
    this.getAllInstallations();

    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-newInstallation") {
        this.getAllInstallations();
        this.isShowInstallationModal = false;
      }
    });
  },
  methods: {
    getAllInstallations() {
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/installation/getAllInstallations",
        {
          method: "get",
          // body: JSON.stringify({
          //   // componentId: 1,
          // }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          this.installations = json;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteInstallationById(installation) {
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/installation/removeInstallation",
        {
          method: "delete",
          body: JSON.stringify({
            id: installation.id,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then(() => {
          this.getAllInstallations();
        })

        .catch((err) => {
          console.log(err);
        });
    },
    showDeleteModal(installation) {
      this.$bvModal
        .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cet utilisateur ?")
        .then((value) => {
          if (value) {
            this.deleteInstallationById(installation);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    showEditModal(installation) {
      this.installation = installation;
      this.isShowInstallationModal = true;

      setTimeout(() => {
        this.$bvModal.show("modal-newInstallation");
      }, 100);
    },
    showModalAddInstallation() {
      this.installation = null;

      this.isShowInstallationModal = true;

      setTimeout(() => {
        this.$bvModal.show("modal-newInstallation");
      }, 100);
    },
    showSettings() {
      // this.installation = null;

      // this.isShowSettings = true;

      setTimeout(() => {
        this.$bvModal.show("modal-settings");
      }, 100);
    },
  },
  watch: {},
  computed: {
    style() {
      return {
        top: this.top + "px",
        left: this.left + "px",
      };
    },
  },
};
</script>
<style>
.context-menu {
  position: fixed;
  background: white;
  z-index: 999;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
}
</style>
